import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent {
  constructor(private router: Router) {}

goBackToApp() {
  window.location.href = 'https://monkey-pen-app-dev.techlabz.in/';
}
}
